const USER_AVATAR_PLACEHOLDER_TEXT_CHARACTER_LIMIT = 2
const DEFAULT_USER_AVATAR_SIZE = 24
const DEFAULT_USER_AVATAR_STACK_SIZE = 3

export {
  USER_AVATAR_PLACEHOLDER_TEXT_CHARACTER_LIMIT,
  DEFAULT_USER_AVATAR_SIZE,
  DEFAULT_USER_AVATAR_STACK_SIZE,
}
